import { createFileRoute, redirect } from '@tanstack/react-router'

// /docs/mcp is a natural guess for the MCP docs (and was 404). The guide lives at
// /guides/mcp; a permanent redirect keeps one canonical page for search engines.
export const Route = createFileRoute('/docs_/mcp')({
  beforeLoad: () => {
    throw redirect({ to: '/guides/mcp', statusCode: 301 })
  },
  component: () => null,
})
